export async function isAuth(){
    const token = window.localStorage.getItem("token");
    return token !== null;
}

export function logout(){
    window.localStorage.removeItem("token");
    window.location.reload();
}